import React, {PropsWithChildren} from 'react';
import {observer} from "mobx-react";
import {VideoSlideLayoutBox} from './boxes/video-slide-layout.box';
import {ThinProgressBarComponent} from "../../progress-bar/thin/thin-progress-bar.component";
import {VideoSlideLayoutProgressIndicatorBox} from "./boxes/video-slide-layout-progress-indicator.box";
import {VideoSlideLayoutChildrenContainerBox} from "./boxes/video-slide-layout-children-container.box";

interface VideoSlideLayoutComponentProps extends PropsWithChildren {
    showProgressIndicator: boolean;
}

export const VideoSlideLayoutComponent: React.FC<VideoSlideLayoutComponentProps> = observer((props) => {
    return (
        <VideoSlideLayoutBox>
            <VideoSlideLayoutChildrenContainerBox>
                {props.children}
            </VideoSlideLayoutChildrenContainerBox>

            <VideoSlideLayoutProgressIndicatorBox>
                <ThinProgressBarComponent show={props.showProgressIndicator}/>
            </VideoSlideLayoutProgressIndicatorBox>

        </VideoSlideLayoutBox>
    )
})